module.exports = __webpack_public_path__ + "img/hr-tree-09-d-trunk.bf50ff95.png";